<template>
	<div>
		<!-- 路由导航 -->
		<div class="routerDh f-bct">
			<div class="l f-ct">
				<div class="t1">当前位置：</div>
				<!-- 培训记录
				<el-image :src="require('@/static/icon55.png')"></el-image>
				<div class="t1">开展信息化系统培训 咸宁市咸安区为液化气从业人员“充电”提能</div>
				<el-image :src="require('@/static/icon55.png')"></el-image> -->
				<div class="t2">员工详情</div>
			</div>
			<div class="r f-ct" @click="back()">
				<div class="t2">培训记录</div>
				<el-image :src="require('@/static/icon56.png')"></el-image>
			</div>
		</div>
		<div class="conBox animate__animated animate__fadeIn" data-wow-duration="0.8s">
		<!-- 筛选 -->
		<div class="shaixuan f-bct">
			<div class="l f-ct">
				<div class="itm">
					<p>状态</p>
					<el-select v-model="orderStatus" placeholder="请选择">
						<el-option
							v-for="item in orderStatusArr"
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="itm">
					<p>类型</p>
					<el-select v-model="orderType" placeholder="请选择">
						<el-option
							v-for="item in orderTypeArr"
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="itm f-ct">
					<p>关键词</p>
					<el-input type="text" v-model="keyword" placeholder="请输入搜索关键词"></el-input>
				</div>
			</div>
			<div class="seachBtn f-ct">
				<div @click="courseOrdercourseOrderList(1)">搜索</div>
				<div @click="keyword='',orderType='',orderStatus='',courseOrdercourseOrderList(1)">重置</div>
			</div>
		</div>
		<!-- 表格 -->
		<div class="zw" v-if="!msgList.length">
			<el-image :src="require('@/static/zw.png')"></el-image>
			<p>暂无相关数据...</p>
		</div>
		<div class="biaoge" v-if="msgList.length">
			<div class="table">
				<div class="th f-ct">
					<div class="t1">序号</div>
					<div class="t2 tl">用户信息</div>
					<div class="t3">学习状态</div>
					<div class="t4 tl">考试情况</div>
					<div class="t5">类型</div>
					<div class="t6">状态</div>
					<div class="t7">证书编号</div>
				</div>
				<div class="td f-ct" v-for="(item,index) in msgList">
					<div class="t1">{{item.id}}</div>
					<div class="t2 umsg">
						<el-image class="uimg" :src="item.memberPortrait"></el-image>
						<div class="r">
							<div class="name f-ct">
								<span>{{item.memberName}}</span>
								<el-image v-if="item.memberGender==1" :src="require('@/static/icon94.png')"></el-image>
								<el-image v-if="item.memberGender==2" :src="require('@/static/icon97.png')"></el-image>
							</div>
							<div class="mobile f-ct">
								<el-image :src="require('@/static/icon95.png')"></el-image>
								<span>{{item.memberMobile}}</span>
							</div>
							<div class="card f-ct">
								<el-image :src="require('@/static/icon96.png')"></el-image>
								<span>{{item.memberIdentityCardCode}}</span>
							</div>
						</div>
					</div>
					<div class="t3">
						<p v-if="item.isCompleteStudy==0">未完成学习</p>
						<p v-if="item.isCompleteStudy==1">已完成学习</p>
						<!-- <p>{{item.completeStudyTime}}</p> -->
					</div>
					<div class="t4" v-if="!item.courseClass">
						暂未分班
					</div>
					<div class="t4 t4txt" v-if="item.courseClass">
						<div class="itm">
							<span>所在班级：</span>{{item.courseClass.name}}
						</div>
						<div class="itm">
							<span>考试次数：</span>{{item.examNum}}
						</div>
						<div class="itm">
							<span>考试分数：</span>{{item.examScore}}
						</div>
						<div class="itm" v-if="item.examStatus==0">
							<span>考试状态：</span>待考试
						</div>
						<div class="itm" v-if="item.examStatus==1">
							<span>考试状态：</span>考试通过
						</div>
						<div class="itm red" v-if="item.examStatus==2">
							<span>考试状态：</span>考试不通过
						</div>
						<div class="itm">
							<span>考试时间：</span>{{item.courseClass.examStartTime}}
						</div>
					</div>
					<div class="t5" v-if="item.orderType==1">首次报名</div>
					<div class="t5" v-if="item.orderType==2">补考订单</div>
					
					<div class="t6" v-if="item.orderStatus==1">待支付</div>
					<div class="t6" v-if="item.orderStatus==2">学习中</div>
					<div class="t6" v-if="item.orderStatus==3">待分班</div>
					<div class="t6" v-if="item.orderStatus==4">待考试</div>
					<div class="t6" v-if="item.orderStatus==5">考试完成</div>
					<div class="t6" v-if="item.orderStatus==6">已发证</div>
					<div class="t6" v-if="item.orderStatus==8">已退款</div>
					<div class="t6" v-if="item.orderStatus==9">已取消</div>
					<div class="t7" v-if="item.memberCertificate">{{item.memberCertificate.certificateNumber}}</div>
					<div class="t7" v-else>/</div>
				</div>
			</div>
			<div class="fenye">
				<el-pagination
				background
				hide-on-single-page
				layout="prev, pager, next,jumper"
				@current-change="goPage"
				:page-size="pageSize"
				:total="total">
				</el-pagination>
			</div>
		</div>
		</div>
	</div>
</template>
<script>
import { courseOrdercourseOrderList,
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			orderStatusArr: [
				{value: '0',label: '全部'}, 
				{value: '1',label: '待支付'}, 
				{value: '2',label: '学习中'}, 
				{value: '3',label: '待分班'}, 
				{value: '4',label: '待考试'}, 
				{value: '5',label: '考试完成'}, 
				{value: '6',label: '已发证'}, 
				{value: '8',label: '已退款'}, 
				{value: '9',label: '已取消'}, 
			],
			orderStatus: '',
			
			orderTypeArr: [
				{value: '0',label: '全部'}, 
				{value: '1',label: '首次报名'}, 
				{value: '2',label: '补考订单'}, 
			],
			orderType: '',
			
			id:0,
			// 筛选
			keyword:'',
			// 分页
			pageNum:1,
			pageSize:10,
			total:0,
			// 列表
			msgList:[],
		}
	},
	mounted() {
		// 参数
		this.id = this.$route.query.id
		// 获取数据
		this.courseOrdercourseOrderList(1)
	},
	methods:{
		// 课程订单列表
		async courseOrdercourseOrderList(def){
			if(def){this.pageNum=1}
			var data = {
				pageSize: this.pageSize,
				pageNum: this.pageNum,
				courseId:this.id,
			}
			if(this.keyword){
				data.memberName = this.keyword
			}
			if(this.orderStatus*1){
				data.orderStatus = this.orderStatus
			}
			if(this.orderType*1){
				data.orderType = this.orderType
			}
			let res = await courseOrdercourseOrderList(data);
			if(res.code==200){
				if(this.pageNum==1){
					this.total = res.total
				}
				this.msgList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 跳转页
		goPage(e){
			// console.log(e)
			this.pageNum = e
			this.courseOrdercourseOrderList()
		},
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.routerDh{
	margin: 0 40px;
	margin-bottom: 24px;
	.l{
		.t1{
			font-size: 16px;
			color: #9A9DA7;
			cursor: pointer;
		}
		.el-image{
			width: 16px;
			height: 16px;
			margin: 0 2px;
		}
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
	}
	.r{
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
		.el-image{
			width: 18px;
			height: 18px;
			margin-left: 6px;
		}
	}
}
.conBox{
	margin: 0 40px;
	background: #fff;
	border-radius: 20px;
}
.shaixuan{
	padding: 0 24px;
	padding-top: 24px;
	margin-bottom: 24px;
	.l{
		width: calc(100% - 200px);
		.itm{
			display: flex;
			align-items: center;
			font-size: 16px;
			margin-right: 31px;
			p{
				display: block;
				margin-right: 16px;
			}
			.el-input{
				width: 287px;
			}
		}
	}
	.seachBtn{
		div{
			width: 85px;
			height: 40px;
			border: 1px solid #DDDDDD;
			font-size: 16px;
			color: #666666;
			text-align: center;
			line-height: 38px;
			cursor: pointer;
			border-radius: 6px;
			&:first-child{
				background: #3B6492;
				border: 1px solid #3B6492;
				color: #fff;
				margin-right: 12px;
			}
		}
	}
}
.biaoge{
	padding: 24px;
	padding-top: 0;
	.table{
		border: 1px solid #EBEEF5;
		border-bottom: 0;
		.t1{
			width: 75px;
		}
		.t2{
			width: 281px;
		}
		.t3{
			width: 138px;
		}
		.t4{
			width: 660px;
		}
		.t5{
			width: 114px;
		}
		.t6{
			width: 114px;
		}
		.t7{
			width: 137px;
		}
		.tl{
			justify-content: flex-start!important;
			padding-left: 20px;
		}
		.th{
			height: 40px;
			border-bottom: 1px solid #EBEEF5;
			background: linear-gradient(180deg, #F8F9FE 0%, #EDEFF6 81.25%);
			div{
				font-size: 14px;
				color: #333333;
				font-weight: bold;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}
		.td{
			border-bottom: 1px solid #EBEEF5;
			align-items: stretch;
			>div{
				color: #333333;
				font-size: 14px;
				border-right: 1px solid #EBEEF5;
				padding: 20px 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-wrap: wrap;
				&:last-child{
					border: none;
				}
			}
			.umsg{
				padding: 20px 12px;
				.uimg{
					width: 54px;
					height: 54px;
					border-radius: 4px;
					margin-right: 12px;
				}
				.r{
					width: calc(100% - 68px);
					.name{
						span{
							font-size: 14px;
							color: #333333;
						}
						.el-image{
							width: 12px;
							height: 12px;
							margin-left: 4px;
						}
					}
					.mobile{
						span{
							font-size: 14px;
							color: #333333;
						}
						.el-image{
							width: 14px;
							height: 14px;
							margin-right: 4px;
						}
					}
					.card{
						span{
							font-size: 14px;
							color: #333333;
						}
						.el-image{
							width: 14px;
							height: 10px;
							margin-right: 4px;
						}
					}
				}
			}
			.t3{
				p{
					&:last-child{
						margin-top: 4px;
					}
				}
			}
			.t4txt{
				padding: 20px 20px;
				padding-bottom: 12px;
				justify-content: flex-start;
				.itm{
					font-size: 14px;
					margin-right: 20px;
					margin-bottom: 8px;
					&:first-child{
						width: 100%;
					}
					&:last-child{
						margin-right: 0;
					}
					span{
						color: #666666;
					}
				}
			}
			.blue{
				color: #3B6492;
			}
			.red{
				color: #FF5F5A;
			}
		}
	}
	.fenye{
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-top: 26px;
		.i1{
			width: 24px;
			height: 24px;
			margin-right: 6px;
		}
		.fyitm{
			width: 32px;
			height: 32px;
			font-size: 12px;
			text-align: center;
			line-height: 32px;
			margin-right: 6px;
			border-radius: 4px;
		}
		.a{
			background: #3B6492;
			color: #fff;
		}
		.i2{
			width: 24px;
			height: 24px;
			margin-right: 19px;
		}
		.linkPage{
			p{
				font-size: 12px;
			}
			.ipt{
				margin: 0 6px;
				width: 42px;
				height: 32px;
				border-radius: 4px;
				background: #F4F4F4;
				.el-select{
					width: 100%;
				}
				::v-deep .el-input__inner{
					border: none;
					background: transparent;
				}
			}
		}
	}
}
</style>